module.exports = __webpack_public_path__ + "static/media/jan 2022.16d3a73e.svg";